<template>
  <v-card flat class="px-6">
    <v-row no-gutters>
      <v-col cols="12" class="body-bold-smaller py-0">
        <a type="primary" size="xsmall" @click="beforeLeave">
          <v-icon size="12" class="backIcon">mdi-arrow-left</v-icon>
          {{ $t('message.actions.return') }}
        </a>
      </v-col>
      <v-col cols="12">
        <span class="title textType3--text">{{
          $t('message.pages.videoOffline.title')
        }}</span>
      </v-col>
      <v-col cols="12" class="mb-5">
        <span class="body-regular-smaller neutral-40-light--text"
          >{{ $t('message.pages.videoOffline.subtitle') }}
          <a target="_blank" type="secondary" :href="offineVideoArticle">
            <span>
              {{ $t('message.embedModal.knowMore') }}
            </span>
            <v-icon size="12">mdi-open-in-new</v-icon>
          </a>
        </span>
      </v-col>
      <v-col v-if="showAlert" cols="12" class="mb-3">
        <v-alert
          dense
          width="100%"
          :color="$vuetify.theme.dark ? '#171924' : '#ffff'"
          :style="`border: 1px solid ${
            $vuetify.theme.dark ? '#0C1C8D' : '#d0d6fb'
          }`"
        >
          <v-row no-gutters class="align-center justify-start">
            <div
              class="d-flex flex-row align-start justify-center mr-4"
              style="height: 100%"
            >
              <v-icon color="primary">mdi-information</v-icon>
            </div>
            <v-col>
              <span class="alertTitle textType3--text">
                {{ $t('message.pages.videoOffline.alertTitle') }}
              </span>
              <br />
              <span
                class="topicSubtitle textType6--text align-text d-block"
                style="color: #c43c3e"
              >
                {{ $t('message.pages.videoOffline.alertSubtitle') }}
              </span>
            </v-col>
            <div
              class="d-flex flex-row align-start justify-center"
              style="height: 100%; width: 30px"
            >
              <v-icon
                style="cursor: pointer"
                color="#B9BBC6"
                size="16"
                @click="handleCloseAlert"
                >mdi-close</v-icon
              >
            </div>
          </v-row>
        </v-alert>
      </v-col>
      <v-col cols="12">
        <span class="body-bold-base">{{
          $t('message.pages.videoOffline.config')
        }}</span>
      </v-col>
      <v-col cols="12" class="mt-4">
        <span class="body-regular-small textType3--text">{{
          $t('message.pages.videoOffline.configCategoryTitle1')
        }}</span>
      </v-col>
      <v-col cols="12" class="line-height-150">
        <v-row no-gutters class="justify-space-between">
          <v-col cols="7">
            <span class="topicSubtitle textType6--text">{{
              $t('message.pages.videoOffline.configCategoryText1')
            }}</span>
          </v-col>
          <v-col cols="5" class="d-flex flex-row align-center justify-end">
            <v-switch
              :disabled="!hasEditVideoPerm"
              v-model="offlineEnabled"
              style="margin: 0; padding: 0"
              inset
              hide-details
            >
            </v-switch>
          </v-col>
        </v-row>
      </v-col>
      <v-row no-gutters v-if="offlineEnabled" class="line-height-150">
        <v-col cols="12" class="mt-3">
          <span class="body-regular-small textType3--text">{{
            $t('message.pages.videoOffline.configCategoryTitle2')
          }}</span>
        </v-col>
        <v-col cols="12">
          <v-row no-gutters class="justify-space-between">
            <v-col cols="7">
              <span class="topicSubtitle textType6--text"
                >{{ $t('message.pages.videoOffline.configCategoryText2') }}
              </span>
            </v-col>
            <v-col cols="5" class="d-flex flex-row align-center justify-end">
              <div class="custom-select">
                <div
                  class="selected-item"
                  :class="
                    $vuetify.theme.dark
                      ? 'selected-item-dark'
                      : 'selected-item-light'
                  "
                  @click="handleOpenSelectTimeModal"
                >
                  <span class="text-container">{{ selectedTime.text }}</span>
                  <v-icon size="16" class="dropdown-icon"
                    >mdi-chevron-down</v-icon
                  >
                </div>
              </div>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12">
          <v-divider class="my-7" />
        </v-col>
        <v-col cols="12" class="pb-4">
          <span class="body-bold-base">{{
            $t('message.pages.video.button')
          }}</span>
        </v-col>
        <v-col cols="12">
          <span class="body-regular-small textType3--text">{{
            $t('message.pages.videoOffline.configCategoryTitle3')
          }}</span>
        </v-col>
        <v-col cols="12">
          <v-row no-gutters class="justify-space-between">
            <v-col cols="7">
              <span class="topicSubtitle textType6--text">{{
                $t('message.pages.videoOffline.configCategoryText3')
              }}</span>
            </v-col>
            <v-col cols="5" class="d-flex flex-row align-center justify-end">
              <v-switch
                v-model="externalBtnToggle"
                style="margin: 0; padding: 0"
                inset
                hide-details
              >
              </v-switch>
            </v-col>
          </v-row>
        </v-col>
        <template v-if="externalBtnToggle">
          <v-col cols="12" class="mt-6">
            <v-row no-gutters align="center">
              <v-col cols="6" class="body-regular-small">{{
                $t('message.pages.videoOffline.btnLink')
              }}</v-col>
              <v-col cols="6">
                <v-row no-gutters>
                  <v-col cols="12">
                    <v-input
                      v-model="externalBtnLink"
                      hide-details
                      dense
                      outlined
                      :placeholder="$t('message.pages.videoOffline.addBtnLink')"
                    ></v-input>
                  </v-col>
                </v-row>
              </v-col>
              <v-col
                v-show="checkDomainRegex"
                cols="12"
                class="align-center justify-center"
                style="height: 28px; padding-top: 6px"
              >
                <span class="red--text caption align-text">
                  <v-icon color="red" size="16" class="pb-1 pt-1 pr-1">
                    mdi-alert-circle
                  </v-icon>
                  {{
                    $t('message.pages.folderSettings.errors.invalidHostname')
                  }}
                  {{ $t('message.pages.folderSettings.errors.domainExample') }}
                </span>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" class="mt-6">
            <v-row no-gutters align="center">
              <v-col cols="6" class="body-regular-small pb-4">{{
                $t('message.pages.videoOffline.btnText')
              }}</v-col>
              <v-col cols="6">
                <v-input
                  v-model="externalBtnText"
                  :hide-details="externalBtnText.length <= 0"
                  dense
                  outlined
                  counter="20"
                  :maxlength="20"
                  :placeholder="$t('message.pages.videoOffline.addBtnText')"
                  :rules="[rules.required, rules.maxLength, rules.minLength]"
                >
                </v-input>
              </v-col>
            </v-row>
          </v-col>
        </template>
      </v-row>
      <v-col cols="12">
        <portal to="actions-footer">
          <ActionModal
            v-if="hasEditVideoPerm"
            :showAction1="hasEditVideoPerm"
            :showAction2="hasEditVideoPerm"
            :disableTooltip1="!withoutChanges"
            :disableTooltip2="!(
              isSaving ||
              (!offlineEnabled && !isDisablingVideoOffline) ||
              isSaveDisabled ||
              withoutChanges
            )"
            :disabledAction1="withoutChanges"
            :disabledAction2="
              isSaving ||
              (!offlineEnabled && !isDisablingVideoOffline) ||
              isSaveDisabled ||
              withoutChanges
            "
            :handleAction1="handleUndoChanges"
            :handleAction2="handleConfirm"
            :loadingAction2="isSaving"
            :action1TooltipText="$t('message.noChanges')"
            :action2TooltipText="
              isSaveDisabled ?
                $t('message.setFieldsCorrectly') :
                $t('message.noChanges')
            "
          />
        </portal>
      </v-col>
    </v-row>
    <unsaved-changes-modal />
    <video-player-offline-modal />
  </v-card>
</template>

<script>
import UnsavedChangesModal from '../../../components/UnsavedChangesModal.vue'
import VideoPlayerOfflineModal from './VideoPlayerOfflineModal.vue'
import ActionModal from '@/components/ActionModal.vue'
import { mapActions, mapMutations, mapState, mapGetters } from 'vuex'
import i18n from '@/translations/lang'
import _ from 'lodash'
import offlineVideoApi from '../../../services/offlineVideoApi'

export default {
  name: 'VideoPlayerOffline',
  components: {
    UnsavedChangesModal,
    VideoPlayerOfflineModal,
    ActionModal,
  },
  props: {
    handleBack: {
      type: Function,
      required: true,
    },
    liveVideoId: {
      required: false,
    },
    hasEdit: {
      type: Array,
    },
  },
  data: () => ({
    offlineEnabled: false,
    offlineEnabledPreviousValue: false,
    selectedTime: {
      text: `30 ${i18n.t('message.pages.videoOffline.days')}`,
      value: 30,
    },
    externalBtnToggle: false,
    externalBtnLink: '',
    externalBtnText: '',
    showAlert: true,
    withoutChanges: true,
    initialConfig: {},
    isSaving: false,
    videoId: '',
    rules: {
      required: (v) => (v && !!v) || i18n.t('message.requiredField'),
      maxLength: (v) =>
        (v && v.length <= 20) || i18n.t('message.maximumLength'),
      minLength: (v) => (v && v.length > 2) || i18n.t('message.minimumLength'),
    },
  }),
  async mounted() {
    this.setDataIfExists()

    const alertClosed = localStorage.getItem('alertClosed')
    if (alertClosed === 'true') {
      this.showAlert = false
    }

    this.initialConfig = _.cloneDeep({
      offlineEnabled: this.offlineEnabled,
      externalBtnToggle: this.externalBtnToggle,
      externalBtnLink: this.externalBtnLink,
      externalBtnText: this.externalBtnText,
      selectedTime: this.selectedTime,
    })

    this.videoId = this.liveVideoId ? this.liveVideoId : this.$route.params.id
    this.$root.$on('discardChanges', () => {
      this.handleUndoChanges()
      this.handleBack()
    })
    this.$root.$on('setOfflineVideoTime', (data) => {
      this.selectedTime = data
    })
  },
  watch: {
    offlineEnabled: 'checkChanges',
    externalBtnToggle: 'checkChanges',
    externalBtnLink: 'checkChanges',
    externalBtnText: 'checkChanges',
    selectedTime: {
      handler: 'checkChanges',
      deep: true,
    },
  },
  computed: {
    ...mapState({
      video: (state) => state.video.video,
      internalError: (state) => state.video.internalError,
    }),
    locale() {
      return this.$i18next.resolvedLanguage
    },
    offineVideoArticle() {
      if (this.locale === 'en') {
        return 'https://help.pandavideo.com/en-us/article/how-to-enable-secure-offline-video-on-the-panda-video-app-info-1txgtge/'
      }
      if (this.locale === 'es') {
        return 'https://help.pandavideo.com/es/article/como-activar-el-video-offline-seguro-en-la-aplicacion-de-panda-video-info-fujayj/'
      }
      return 'https://help.pandavideo.com/pt-br/article/como-ativar-o-video-offline-seguro-no-aplicativo-da-panda-video-infoprodutor-20f2tv/'
    },
    checkDomainRegex() {
      let link = this.externalBtnLink
      if (link.length < 2) {
        return false
      }
      const pattern = new RegExp(
        /^(https?):\/\/([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(\/\S*)?$/
      )
      return !pattern.test(link)
    },
    ...mapGetters('user', ['hasEditVideoPerm']),
    isDisablingVideoOffline() {
      return this.offlineEnabledPreviousValue && !this.offlineEnabled
    },
    isSaveDisabled() {
      if (this.externalBtnToggle) {
        // Verifica se os campos obrigatórios foram preenchidos corretamente
        const isTextValid = this.externalBtnText.length >= 3
        const isLinkValid =
          this.externalBtnLink.length >= 3 && !this.checkDomainRegex

        return this.externalBtnToggle ? !(isTextValid && isLinkValid) : false
      }
      return false
    },
    isPublishDisabled() {
      if (this.externalBtnToggle) {
        const isTextValid = this.externalBtnText.length >= 3

        const isLinkValid =
          this.externalBtnLink.length >= 3 && !this.checkDomainRegex

        return !isTextValid || !isLinkValid
      }

      return false
    },
  },
  methods: {
    ...mapActions('video', []),
    ...mapMutations('video', ['UPDATE_VIDEO_CONFIG']),
    ...mapMutations('video', ['UPDATE_VIDEO', 'UPDATE_STATUS_ERROR']),
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    handleCloseAlert() {
      this.showAlert = false
      localStorage.setItem('alertClosed', 'true')
    },
    getPossibleTimesList() {
      return [
        { text: `7 ${i18n.t('message.pages.videoOffline.days')}`, value: 7 },
        { text: `15 ${i18n.t('message.pages.videoOffline.days')}`, value: 15 },
        { text: `30 ${i18n.t('message.pages.videoOffline.days')}`, value: 30 },
        { text: `60 ${i18n.t('message.pages.videoOffline.days')}`, value: 60 },
        { text: i18n.t('message.pages.videoOffline.neverExpire'), value: -1 },
        {
          text: i18n.t('message.pages.videoOffline.other'),
          value: null,
          isOther: true,
        },
      ]
    },
    handleUndoChanges() {
      this.offlineEnabled = this.initialConfig.offlineEnabled
      this.externalBtnToggle = this.initialConfig.externalBtnToggle
      this.externalBtnLink = this.initialConfig.externalBtnLink
      this.externalBtnText = this.initialConfig.externalBtnText
      this.selectedTime = _.cloneDeep(this.initialConfig.selectedTime)
      this.checkChanges()
    },
    setDataIfExists() {
      const { config, video_offline } = this.$store.state.video.video
      const offlineDataSession = sessionStorage.getItem(
        `video_offline_enabled_${this.video.id}`
      )
      const isOfflineEnabled = offlineDataSession === 'true'
      this.offlineEnabled =
        offlineDataSession !== null
          ? isOfflineEnabled
          : config?.video_offline_enabled || false
      this.offlineEnabledPreviousValue = config?.video_offline_enabled || false
      this.externalBtnToggle =
        video_offline?.external_link_button_enabled || false
      this.externalBtnText = video_offline?.external_link_text || ''
      this.externalBtnLink = video_offline?.external_link_url || ''

      const expireDays = video_offline?.expire_in_days_video
      if (expireDays !== undefined) {
        const possibleTimesList = this.getPossibleTimesList()
        const selectedOption = possibleTimesList.find(
          (option) => option.value === expireDays
        )

        this.selectedTime = selectedOption || {
          text: i18n.t('message.pages.videoOffline.other'),
          value: expireDays,
          isOther: true,
        }
      }
    },
    async handleConfirm() {
      this.isSaving = true
      try {
        await this.handleOfflineVideoSave()

        this.initialConfig = _.cloneDeep({
          offlineEnabled: this.offlineEnabled,
          externalBtnToggle: this.externalBtnToggle,
          externalBtnLink: this.externalBtnLink,
          externalBtnText: this.externalBtnText,
          selectedTime: this.selectedTime,
        })

        this.checkChanges()
      } catch (e) {
        this.handleSnackbar(i18n.t('message.errors.unexpectedError'))
      } finally {
        this.handleSnackbar()
        this.isSaving = false
      }
    },
    handleOpenSelectTimeModal() {
      const possibleTimesInfo = this.getPossibleTimesList()
      this.$root.$emit('openVideoPlayerOfflineModal', {
        selectedTime: this.selectedTime,
        possibleTimes: possibleTimesInfo,
      })
    },
    enableOfflineVideoSwitch() {
      this.offlineEnabled = !this.offlineEnabled
    },
    async handleOfflineVideoSave() {
      const offlineData = {
        video_offline_enabled: this.offlineEnabled,
        expire_in_days_video: this.selectedTime.value,
        external_link_button_enabled: this.externalBtnToggle,
        external_link_url: this.externalBtnLink,
        external_link_text: this.externalBtnText,
      }
      try {
        await offlineVideoApi.setVideoToOfflineEnabled(
          this.videoId,
          offlineData
        )
        this.offlineEnabledPreviousValue = this.offlineEnabled
        const updatedVideo = {
          ...this.video,
          config: {
            ...this.video.config,
            video_offline_enabled: offlineData.video_offline_enabled,
          },
          video_offline: {
            expire_in_days_video: offlineData.expire_in_days_video,
            external_link_button_enabled:
              offlineData.external_link_button_enabled,
            external_link_text: offlineData.external_link_text,
            external_link_url: offlineData.external_link_url,
          },
        }
        this.UPDATE_VIDEO(updatedVideo)
        this.UPDATE_VIDEO_CONFIG({
          ...this.video.config,
          video_offline_enabled: offlineData.video_offline_enabled,
        })
        sessionStorage.setItem(
          `video_offline_enabled_${this.video.id}`,
          offlineData.video_offline_enabled
        )
        this.$root.$emit('updateEmbedPreviewChange')
      } catch (e) {
        console.log('error', e)
      }
    },
    checkChanges() {
      this.withoutChanges = _.isEqual(this.initialConfig, {
        offlineEnabled: this.offlineEnabled,
        externalBtnToggle: this.externalBtnToggle,
        externalBtnLink: this.externalBtnLink,
        externalBtnText: this.externalBtnText,
        selectedTime: this.selectedTime,
      })
    },
    beforeLeave() {
      if (this.isSaving) return
      this.handleBack()
    },
    handleSnackbar(item) {
      if (!item) {
        item = i18n.t('message.changesSaved')
      }
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: item,
        type: 'success',
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.backToConfig {
  font-size: 12px;
  font-weight: 500;
}
.line-height-150 {
  line-height: 18px !important;
}
.title {
  font-size: 20px;
}
.subtitle {
  font-size: 12px;
}
.alertTitle {
  font-size: 14px;
}
.topicsTitle {
  font-size: 14px;
}
.topicTitle {
  font-size: 12px;
}
.topicSubtitle {
  font-size: 12px;
}
.knowMore {
  font-size: 12px;
  font-weight: 700px;
}
.configText {
  line-height: 150%; /* 16.5px */
  letter-spacing: 0.66px;
}
.custom-select {
  position: relative;
  width: 84px;
  font-size: 12px;
}

.selected-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 8px;
  border-radius: 8px;
  cursor: pointer;
  height: 32px;
  line-height: 24px;
  box-sizing: border-box;
}

.selected-item-light {
  border: 1px solid varFigma(neutral-95-lightest);
  background-color: white;
}
.selected-item-dark {
  border: 1px solid #363949;
}

.text-container {
  flex-grow: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 500;
  margin-right: 2px;
}

.selected-item:hover {
  border-color: #aaa;
}

.dropdown-icon {
  flex-shrink: 0; /* Ensures icon doesn't get squeezed */
  margin-left: 2px;
}
</style>
